/**
 * Обложка события без обрезания: картинка целиком (contain) поверх
 * мягкого размытого фона из неё же (cover допустим только для фона).
 */
export function SquareCover({
  url,
  title,
  className,
}: {
  url: string;
  title: string;
  className?: string;
}) {
  return (
    <div className={`relative overflow-hidden ${className ?? ""}`}>
      <img
        src={url}
        alt=""
        aria-hidden
        loading="lazy"
        decoding="async"
        className="absolute inset-0 h-full w-full scale-110 object-cover blur-md brightness-90 saturate-75"
      />
      <img
        src={url}
        alt={title}
        loading="lazy"
        decoding="async"
        className="relative h-full w-full object-contain"
      />
    </div>
  );
}
